import React from 'react'
import {
  Grid,
  MenuItem,
  Select,
  Typography,
  FormLabel,
  Button
} from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import {
  load,
  setTotalRows,
  setGene,
  setClinicalSignificance
} from "./store"
import { loadData } from './utilities.js';

function Filters(){

  const { clinicalSignificance, gene } = useSelector((state) => state.clinvarData)
  const dispatch = useDispatch()

  const handleFetch = async () => {
    try {
      const data = await loadData({ 'gene': gene, 'clinical_significance': clinicalSignificance })
      dispatch(load(data['rows']))
      dispatch(setTotalRows(data['totalRows']))
    } catch (error) {
      console.error(error.message)
    }
  }

  const handleClinicalSignificance = (value) => {
    dispatch(setClinicalSignificance(value))
  }

  const handleGene = (value) => {
    dispatch(setGene(value))
  }

  return (
    <Grid container sx={{ display: 'flex', flexDirection: 'column' }}>
      <Grid item md={12} sx={{ mb: 3 }}>
        <Typography variant='h4'>Filters</Typography>
      </Grid>
      <Grid item md={12} sx={{ mb: 3, pt: 1 }}>
          <Typography variant='body1'><b>Instructions: </b>Select from the drop-down below,
          then press the fetch button. Results will be displayed on the right.</Typography>
      </Grid>
      <Grid
        container
        sx={{ display: 'flex', flexDirection: 'column' }}
        rowSpacing={2}
      >
        <Grid item>
          <FormLabel>
            <Typography variant='body2'>Gene</Typography>
          </FormLabel>
          <Select
            fullWidth
            size='small'
            value={gene}
            onChange={(e) => {
              handleGene(e.target.value)
            }}
          >
            <MenuItem value={'no_filter'}>No filter</MenuItem>
            <MenuItem value={'BRCA1'}>BRCA1</MenuItem>
            <MenuItem value={'BRCA2'}>BRCA2</MenuItem>
            <MenuItem value={'CFTR'}>CFTR</MenuItem>
            <MenuItem value={'G6PD'}>G6PD</MenuItem>
            <MenuItem value={'PTEN'}>PTEN</MenuItem>
            <MenuItem value={'TP53'}>TP53</MenuItem>
          </Select>
        </Grid>
        <Grid item>
          <FormLabel>
            <Typography variant='body2'>Clinical Significance</Typography>
          </FormLabel>
          <Select
            fullWidth
            size='small'
            value={clinicalSignificance}
            onChange={(e) => {
              handleClinicalSignificance(e.target.value)
            }}
          >
            <MenuItem value={'no_filter'}>No filter</MenuItem>
            <MenuItem value={'benign'}>Benign</MenuItem>
            <MenuItem value={'likely_benign'}>Likely benign</MenuItem>
            <MenuItem value={'likely_pathogenic'}>Likely pathogenic</MenuItem>
            <MenuItem value={'pathogenic'}>Pathogenic</MenuItem>
            <MenuItem value={'uncertain_significance'}>Uncertain significance</MenuItem>
            <MenuItem value={'not_provided'}>not provided</MenuItem>
            <MenuItem value={'not_reported_for_simple_variant'}>not reported for simple variant</MenuItem>
          </Select>
        </Grid>
        <Grid item sx={{ mt: 3 }}>
            <Button variant='contained' onClick={handleFetch}>
              Fetch filtered data
            </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Filters
